import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import FormControl from "@material-ui/core/FormControl";
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as actions from "../store/actions/index";
import Grid from "@material-ui/core/Grid";
import queryString from 'query-string'
import converter from "number-to-chinese-words";
import CircularProgress from '@material-ui/core/CircularProgress';
// var converter = require('number-to-chinese-words');

const styles = (theme) => ({
  container: {
    width: "95%",
  },
  root: {
    width: "100%",
    // minHeight: "500px",
    //marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    margin: "0 Auto",
    padding:"20px"
    //display: 'flex',
    //justifyContent: 'center',
  },
  table: {
    tableLayout: "auto",
    minWidth: 300,
  },
  header: {
    backgroundColor: "primary",
  },
  leftCell: {
    borderRight: "0.1em solid rgba(224, 224, 224, 1)",
  },
  margin: {
    margin: "20px",
  },
  textField: {
    width: 200,
  },
});

class ArbitrationAgreementsPrint extends Component {
  state = {
    agreementNo: localStorage.getItem('agreementNo'),
    date: localStorage.getItem('date'),
    description: localStorage.getItem('description'),

    firstpartyname: localStorage.getItem('firstpartyname'),
    firstpartyemail: localStorage.getItem('firstpartyemail'),
    firstpartysig: localStorage.getItem('firstpartysig'),

    secondpartyname: localStorage.getItem('secondpartyname'),
    secondpartyemail: localStorage.getItem('secondpartyemail'),
    secondpartysig: localStorage.getItem('secondpartysig'),
  };

  componentDidMount() {

     setTimeout(()=>{
      window.print()
     },1000)
    
  }

  render() {
    const { classes } = this.props;
        return (
        <div className={classes.root}>
        <style>
          {`@media print {body {zoom: 90%;}}`}
        </style>
          
              <div style={{}}>
                <table width="100%">
                <tr width="100%">
                  <Typography
                        width="100%"
                        variant="h4"
                        align="center"
                        gutterBottom
                        FullWidth
                      >
                        {this.context.t("Arbitration Agreement")}
                      </Typography>
                  </tr>
                </table>
                <br/>
                <table>
                 
                  <tr>
                    <td width="20%">
                      <Typography
                        width="100%"
                        variant="h5"
                        align="justify"
                        gutterBottom
                        FullWidth
                      >
                        {this.context.t("AgreementNo")}: {this.state.agreementNo}
                      </Typography>
                    </td>

                    <td>
                      <Typography
                        width="100%"
                        variant="h5"
                        align="justify"
                        gutterBottom
                        FullWidth
                      >
                      </Typography>
                    </td>

                    <td width="20%">
                      <Typography
                        width="100%"
                        variant="h5"
                        align="justify"
                        gutterBottom
                        FullWidth
                      >
                        {this.context.t("Date")}: {this.state.date}
                      </Typography>
                    </td>
                    
                  </tr>

                </table>

                <div>            
                  <table>
                    <tr width="100%">
                      <Typography
                        width="100%"
                        variant="h5"
                        align="justify"
                        gutterBottom
                        FullWidth
                      >
                        <br />
                        {this.context.t("arbitration_agreement1")}
                      </Typography>
                    </tr>
                  </table>

                  <Grid
                    container
                    spacing={16}
                    style={{marginLeft: '0px'}}
                    alignItems="left"
                    direction="row"
                    justify="left"
                  >
                    <Grid alignItems="left" direction="row" justify="left">
                      <Typography
                        width="100%"
                        variant="h5"
                        align="left"
                        gutterBottom
                        FullWidth
                      >
                        {/* <br /> */}
                        {/* {this.context.t("arbitration_agreement2")} */}
                        <br />
                        {this.state.description}
                      </Typography>
                    </Grid>
                  </Grid>

                  <br />
                  {this.context.t("arbitration_agreement3")}

                  <Grid
                    container
                    spacing={16}
                    alignItems="center"
                    direction="row"
                    justify="center"
                  >
                    <Grid
                      container
                      spacing={16}
                      alignItems="center"
                      direction="row"
                      justify="center"
                    >
                      <Grid alignItems="center" direction="row" justify="center">
                        <FormControl className={classes.margin}>
                          <FormControl className={classes.margin}>
                            <Typography
                              width="100%"
                              variant="h5"
                              align="justify"
                              gutterBottom
                              FullWidth
                            >
                              <br />
                              {this.context.t("Name of 1st Party")}
                              <br />
                              {this.state.firstpartyname}
                            </Typography>
                          </FormControl>

                          <FormControl className={classes.margin}>
                            <Typography
                              width="100%"
                              variant="h5"
                              align="justify"
                              gutterBottom
                              FullWidth
                            >
                              <br />
                              {this.context.t("E-mail of 1st Party")}
                              <br />
                              {this.state.firstpartyemail}
                            </Typography>
                          </FormControl>

                          <FormControl className={classes.margin}>
                            <Typography>
                              {this.context.t("Signature of 1st Party:")}
                            </Typography>
                            <img
                              src={`data:image/jpeg;base64,${
                                this.state.firstpartysig
                              }`}
                              style={{
                                marginRight: "40px",
                                width: "400px",
                                height: "200px",
                              }}
                            />
                          </FormControl>
                        </FormControl>
                      </Grid>
                      <Grid alignItems="center" direction="row" justify="center">
                        <FormControl className={classes.margin}>
                          <FormControl className={classes.margin}>
                            <Typography
                              width="100%"
                              variant="h5"
                              align="justify"
                              gutterBottom
                              FullWidth
                            >
                              <br />
                              {this.context.t("Name of 2nd Party")}
                              <br />
                              {this.state.secondpartyname}
                            </Typography>
                          </FormControl>

                          <FormControl className={classes.margin}>
                            <Typography
                              width="100%"
                              variant="h5"
                              align="justify"
                              gutterBottom
                              FullWidth
                            >
                              <br />
                              {this.context.t("E-mail of 2nd Party")}
                              <br />
                              {this.state.secondpartyemail}
                            </Typography>
                          </FormControl>

                          <FormControl className={classes.margin}>
                            <Typography>
                              {this.context.t("Signature of 2nd Party:")}
                            </Typography>
                            <img
                              src={`data:image/jpeg;base64,${
                                this.state.secondpartysig
                              }`}
                              style={{
                                marginRight: "40px",
                                width: "400px",
                                height: "200px",
                              }}
                            />
                          </FormControl>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                  
                </div>  
              </div>
        </div>
      );
    

    
  }
}

ArbitrationAgreementsPrint.contextTypes = {
  t: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    arbiAgreement: state.arbiAgreement.arbiAgreement,
    getAllAgreement: state.arbiAgreement.getAllAgreement,
    loading: state.arbiAgreement.loading,
    agreements: state.arbiAgreement.agreements,
    lang: state.i18nState.lang,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllArbiAgreement: () => dispatch(actions.getAllArbiAgreement()),
  };
};

// export default withStyles(styles)(ArbitrationAgreement);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(ArbitrationAgreementsPrint)));
